const defaultFiledClass = {
  thClass: '!capitalize !text-black',
  tdClass: '!text-black',
}

/**
 * Konfigurasi kolom untuk tabel daftar tagihan
 *
 * Konfigurasi ini digunakan untuk menampilkan kolom-kolom yang akan ditampilkan pada tabel daftar tagihan
 * yaitu periode, jenis tagihan, nominal tagihan, dan aksi.
 * Konfigurasi ini juga digunakan untuk mengatur class yang akan diterapkan pada tabel daftar tagihan.
 */
// eslint-disable-next-line import/prefer-default-export
export const DaftarInvoiceFields = [
  {
    key: 'period',
    label: 'Periode',
    ...defaultFiledClass,
  },
  {
    key: 'bill_type',
    label: 'Jenis Tagihan',
    ...defaultFiledClass,
  },
  {
    key: 'amount',
    label: 'Nominal Tagihan',
    formatter: value => `Rp ${(value || 0).toLocaleString('id-ID')}`,
    ...defaultFiledClass,
  },
  {
    key: 'status',
    label: 'Status',
    formatter: value => {
      if (value === 'PAID') {
        return 'Lunas'
      }
      return 'Belum Lunas'
    },
    ...defaultFiledClass,
  },
  {
    key: 'ref_id',
    label: 'Aksi',
    ...defaultFiledClass,
  },
]
